var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.375,29.628v3.667c0,.825-.66,1.375-1.375,1.375h-1.375v-6.417h1.375c.715,0,1.375.55,1.375,1.375ZM14.778,28.125h-1.302v2.695h1.302c.752,0,1.393-.623,1.393-1.338s-.642-1.338-1.393-1.338v-.018ZM33.167,3.082v8.085h8.085l-8.085-8.085ZM42.333,14.833v31.167H5.667V7.5c0-3.043,2.457-5.5,5.5-5.5h18.333v12.833h12.833ZM18.463,29.463c0-1.998-1.65-3.63-3.685-3.63h-3.612v11.128h2.292v-3.85h1.32c2.035,0,3.685-1.632,3.685-3.648ZM27.667,29.592c0-1.998-1.632-3.63-3.667-3.63h-3.667v11h3.667c2.035,0,3.667-1.632,3.667-3.63v-3.74ZM36.833,25.833h-7.333v11.128h2.292v-3.85h3.208v-2.292h-3.19v-2.695h5.042v-2.292h-.018Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.54b4e3b5b85f397eecdd02d7a6ba3da9.svg";
export { ForwardRef as ReactComponent };